import React from "react";

const KakaoLoginButton = () => {
  const handleKakaoLogin = () => {
    window.location.href = "/oauth2/authorization/kakao";
  };

  // ✅ 컴포넌트 안으로 이동
  const handleGuestLogin = async () => {
    try {
      const res = await fetch('/api/auth/guest', { method: 'POST' });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('role', 'GUEST');
        localStorage.setItem('nickname', '게스트');
        window.location.reload();
      }
    } catch (e) {
      alert('게스트 로그인 실패. 다시 시도해주세요.');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
      {/* 카카오 로그인 버튼 (기존) */}
      <button
        onClick={handleKakaoLogin}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          backgroundColor: "#FEE500",
          color: "#000000",
          border: "none",
          borderRadius: "8px",
          padding: "10px 20px",
          fontSize: "14px",
          fontWeight: "bold",
          cursor: "pointer",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <img
          src="https://developers.kakao.com/assets/img/about/logos/kakaolink/kakaolink_btn_small.png"
          alt="카카오"
          style={{ width: "20px", height: "20px" }}
        />
        카카오 로그인
      </button>

      {/* 구분선 */}
      <div style={{ 
  color: '#999', 
  fontSize: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%'
}}>
  {/* <div style={{ flex: 1, height: '1px', background: '#ddd' }} />
  또는
  <div style={{ flex: 1, height: '1px', background: '#ddd' }} /> */}
</div>

{/* 게스트 버튼 */}
{/* <button
  onClick={handleGuestLogin}
  style={{
    width: "100%",
    padding: "10px 20px",
    background: "#f8f8f8",          // ✅ 투명 → 연한 회색 배경
    border: "1.5px solid #bbb",     // ✅ #ddd → #bbb (더 진한 테두리)
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "bold",             // ✅ bold 추가
    color: "#333",                  // ✅ #555 → #333 (더 진한 글자)
    cursor: "pointer",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",  // ✅ 그림자 추가
  }}
>
  🔍 로그인 없이 둘러보기
</button> */}

{/* 안내 문구 */}
{/* <p style={{ 
  fontSize: '11px', 
  color: '#999',       // ✅ #aaa → #999
  textAlign: 'center', 
  margin: 0,
  lineHeight: '1.5'
}}>
  둘러보기 모드에서는 지도 탐색·검색만 가능합니다.
</p> */}
    </div>
  );
};

export default KakaoLoginButton;